/**
 * PWA service-worker registration with automatic updates.
 *
 * autoUpdate (vite.config) + skipWaiting/clientsClaim: new deploys replace a
 * stale precache that otherwise soft-404s newer curated /ferge/kai/:slug pages.
 * SoftNotFound also runs a one-shot unregister/reload for kai soft-404s.
 */
import { registerSW } from "virtual:pwa-register";

export function installSwUpdatePrompt(): void {
  if (!("serviceWorker" in navigator)) return;

  registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      // Periodic check so long-lived tabs notice publishes without a reload.
      if (!registration) return;
      window.setInterval(() => {
        void registration.update();
      }, 60 * 60 * 1000);
    },
  });
}
